<script setup>
import { ref } from 'vue';
import Main from './hoc/main.vue';
import { getLocale } from './utility/date-formatter';
import { stringFormatter } from './utility/string';
import setMasonry from './utility/masonry';

const props = defineProps({
  jsonUrl: {
    type: String,
    required: true,
    default() {
      return '';
    },
  },
});

// Data
const activeView = ref('list');

// Methodes
const isList = () => {
  const isListView = activeView.value === 'list';
  return isListView;
};

const masonryHandler = (el) => {
  const masonryItem = el;
  if (!isList()) {
    return setMasonry(masonryItem);
  }
  masonryItem.style.height = 'auto';
  return null;
};

const changeView = (view) => { activeView.value = view; };
</script>

<template>
  <div class="grid">
    <Main
      :endpoint="props.jsonUrl"
      :filter-obj="{
        query: '',
        topic: '',
        section: '',
      }"
      :paginate="true"
    >
      <template #filters="{ onFilterChanged, clearQueryFilter, listItems, firstLoad }">
        <section
          v-if="firstLoad || listItems?.length"
          class="section"
        >
          <div class="grid col-4">
            <div class="InputWithIcon">
              <Select2
                :options="essity.filters.newsFeatures.topic || []"
                :placeholder="essity.filters.newsFeatures.topic[0].text"
                @selecthandler="
                  ($event) => onFilterChanged({ topic: $event.id })
                "
              />
            </div>
            <div class="InputWithIcon">
              <Select2
                :options="essity.filters.newsFeatures.year"
                :placeholder="essity.filters.newsFeatures.year[0].text"
                @selecthandler="
                  ($event) => onFilterChanged({ year: $event.id })
                "
              />
            </div>

            <div
              class="InputWithIcon InputWithIcon--alignRight InputWithIcon--iconLarge"
            >
              <i
                class="i i-search txt-secondary"
                aria-hidden="true"
              />
              <input
                id="download-media-search"
                name="query"
                class="form-control"
                type="search"
                :placeholder="
                  essity.translations.newsFeatures.searchPlaceholder
                "
                @keyup="
                  ($event) => onFilterChanged({ query: $event.target.value })
                "
                @click="clearQueryFilter"
              >
            </div>

            <div class="pull-right">
              <!-- Tab Group START -->
              <div class="btn-group result-orientation">
                <button
                  type="button"
                  role="tab"
                  :aria-selected="activeView === 'list'"
                  :aria-label="essity.translations.buttonLabels.list"
                  class="btn btn--tab"
                  :class="activeView === 'list' ? 'active' : ''"
                  @click="() => changeView('list')"
                >
                  <i class="i i-list" />
                </button>
                <button
                  type="button"
                  role="tab"
                  :aria-selected="activeView === 'masonry'"
                  :aria-label="essity.translations.buttonLabels.masonry"
                  class="btn btn--tab"
                  :class="activeView === 'masonry' ? 'active' : ''"
                  @click="() => changeView('masonry')"
                >
                  <i class="i i-grid" />
                </button>
              </div>
              <!-- Tab Group END -->
            </div>
          </div>
        </section>
      </template>
      <template #default="{ listItems }">
        <div
          :ref="masonryHandler"
          :class="[isList() ? 'result-list' : 'masonry-list', { 'is-loading' : isLoading }]"
        >
          <div
            v-for="item of listItems"
            :key="item"
            :class="[isList() ? 'result-item' : 'masonry-item']"
          >
            <div
              v-if="item.img && activeView === 'masonry'"
              class="media ratio-3x2"
            >
              <img
                alt
                :src="item.img"
              >
            </div>
            <p
              v-if="item.date"
              class="date no-margin"
            >
              {{ getLocale(item.date) }}
            </p>

            <h5 class="no-margin">
              <a
                :href="item.url"
                class="txt-primary"
              >
                <!-- eslint-disable vue/no-v-html -->
                <span v-html="item.title" />
                <i
                  v-if="isList()"
                  class="i i-caret-right txt-secondary"
                />
              </a>
            </h5>
            <!-- eslint-disable vue/no-v-html -->
            <p
              v-if="item.body"
              class="item-body-text"
              v-html="stringFormatter(item.body, 30)"
            />

            <div
              v-if="activeView === 'masonry'"
              class="result-list-action"
            >
              <div class="link-group">
                <div>
                  <a
                    :href="item.url"
                    class="txt-secondary i i-link-arrow"
                  >{{
                    essity.translations.general.readMore
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Main>
  </div>
</template>
